import * as React from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { useState } from 'react'; // Import useState

// Customized tooltip that shows "Off" when the value is 0
function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value === 0 ? 'Auto' : value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

// Styling for the custom slider
const PrettoSlider = styled(Slider)({
  color: '#008080',
  height: 8,
  '& .MuiSlider-root ': {
    paddingTop: '10px !important',
    paddingBottom: '10px !important',
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,

    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#008080',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

// Custom thumb component for the slider (optional if needed)
function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

AirbnbThumbComponent.propTypes = {
  children: PropTypes.node,
};

export default function CustomizedSlider({ label, min, max, value, setValue }) {
  const handleSliderChange = (event, newValue) => {
    setValue(newValue); // Call the parent function to update parent state
  };

  return (
    <Box sx={{ width: '95%', margin: 'auto' }}>
      <Typography gutterBottom className="fw-medium accentColor mb-2">
        {label}
      </Typography>
      {/* <div className='bordered'>  */}
     
      <PrettoSlider
        valueLabelDisplay="auto"
        aria-label="pretto slider"
        value={value} // Bind the state value to the slider
        min={min}
        max={max}
        step={10}
        className="mt-md-1"
        onChange={handleSliderChange} // Update the value on change
        slots={{
          thumb: AirbnbThumbComponent,
          valueLabel: ValueLabelComponent,
        }} // Use the new slots API
      />
       {/* </div> */}
    </Box>
  );
}
